import classes from "./Acuerdo.module.css";

function Acuerdo(props) {
  return (
    <div className={classes.mainContainer}>
      <div className={classes.option}>
        <input
          type="radio"
          name=""
          value=" "
          checked={props.value === " "}
          onChange={() => {
            props.setValue(" ");
          }}
        />
        <div>NA</div>
      </div>
      <div className={classes.option}>
        <input
          type="radio"
          name=""
          value="0"
          checked={props.value === 0}
          onChange={() => {
            props.setValue(0);
          }}
        />
        <div>NS / NC</div>
      </div>
      <div className={classes.option}>
        <input
          className={classes.checkBad}
          type="radio"
          name=""
          value="1"
          checked={props.value === 1}
          onChange={() => {
            props.setValue(1);
          }}
        />
        <div>No</div>
      </div>
      <div className={classes.option}>
        <input
          className={classes.checkNeutral}
          type="radio"
          name=""
          value="2"
          checked={props.value === 2}
          onChange={() => {
            props.setValue(2);
          }}
        /><div>Medianamente</div>
      </div>
      <div className={classes.option}>
        <input
          className={classes.checkGood}
          type="radio"
          name=""
          value="3"
          checked={props.value === 3}
          onChange={() => {
            props.setValue(3);
          }}
        /><div>Sí</div>
      </div>
    </div>
  );
}

export default Acuerdo;
